/**
 * @module Popup
 */
;(function Popup() {
    function popup($initialPopup) {
        /**
         * local object availability
         * @type {popup}
         * @private
         */
        var _this = this

        /**
         * only set cookie once one  click
         * @type {boolean}
         * @private
         */
        var cookieSet = false

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var key = $initialPopup.attr('id')

            // Don't show the popup if a cookie exists
            if (_this.getCookie(key) === null) {
                $initialPopup.find('.modal').modal('show')
                _this.cookieOnInteractionEvent(key)
            }
        }

        /**
         * to ensure that user saw the popup set cookie at click interaction on popup
         * @param key popup identifier
         * @private
         */
        this.cookieOnInteractionEvent = function (key) {
            $initialPopup.find('.modal-content').click(function () {
                if (cookieSet === false) {
                    _this.setCookie(key, 1, 10)
                    cookieSet = true
                }
            })
        }

        /**
         * Sets a new cookie
         * Found on: https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
         * @param name
         * @param value
         * @param days
         */
        this.setCookie = function (name, value, days) {
            var expires = ''
            if (days) {
                var date = new Date()
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
                expires = '; expires=' + date.toUTCString()
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/'
        }

        /**
         * Gets an existing cookie
         * Found on: https://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
         * @param name
         * @returns {string|null}
         */
        this.getCookie = function (name) {
            var nameEQ = name + '='
            var ca = document.cookie.split(';')
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i]
                while (c.charAt(0) == ' ') c = c.substring(1, c.length)
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
            }
            return null
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.popup = popup
})()

$(document).ready(function () {
    var $initialPopup = $('.js-initial-popup')
    if ($initialPopup.length) {
        new window.Creaton.popup($initialPopup)
    }
})
